exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bo-cart-address-body[data-v-bbe0635e]{margin-top:10vh;padding-left:10vw;padding-right:10vw;text-align:left}.address-input[data-v-bbe0635e]{resize:none;min-height:10vh;width:100%}.notes-input[data-v-bbe0635e]{resize:none;min-height:20vh;width:100%}.name-input[data-v-bbe0635e]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bbe0635e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/CartAddress.vue
// module id = 442
// module chunks = 0